import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Briefcase, Star } from "lucide-react";

export const JobCard = ({ vaga, index = 0 }) => (
  <Link
    to={`/vaga/${vaga.id}`}
    data-testid={`job-card-${vaga.id}`}
    style={{ animationDelay: `${index * 60}ms` }}
    className="animate-rise block bg-white rounded-3xl p-6 border border-slate-200 shadow-[0_8px_32px_rgba(0,0,0,0.04)] hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
  >
    <div className="flex justify-between items-start gap-3 mb-4">
      <span className="bg-blue-100 text-blue-800 text-xs font-extrabold px-3 py-1 rounded-full flex items-center gap-1">
        <MapPin size={12} /> {vaga.cidade}
      </span>
      {vaga.featured ? (
        <span className="bg-emerald-100 text-emerald-800 text-xs font-extrabold px-3 py-1 rounded-full flex items-center gap-1">
          <Star size={12} /> Destaque
        </span>
      ) : (
        <span className="bg-slate-100 text-slate-700 text-xs font-extrabold px-3 py-1 rounded-full">
          {vaga.tipo}
        </span>
      )}
    </div>
    <h3 className="font-heading text-xl font-extrabold tracking-tight text-slate-950">{vaga.cargo}</h3>
    <p className="text-slate-500 font-bold mt-1 flex items-center gap-1">
      <Briefcase size={14} /> {vaga.company_name}
    </p>
    <p className="mt-4 text-slate-600 leading-relaxed line-clamp-2">{vaga.descricao}</p>
    <p className="mt-4 font-extrabold text-slate-950">Salário: {vaga.salario}</p>
    <span className="mt-5 inline-block text-emerald-700 font-extrabold">Ver vaga →</span>
  </Link>
);
